import { ControlType, Item } from '../../workspaces/item';
import Workspace from '../../workspaces';
import templates from '../templates';

const select = (() => {
    let _visible = false;
    let $dialog = null;
    let $template = null;

    const _close = () => $dialog.close();

    const _onClose = () => {
        _visible = false;
        $dialog.destroy();
        return $template.remove();
    };

    return (values, submit, close) => {
        if (_visible) {
            return;
        }

        _visible = true;

        const _submit = e => {
            e.preventDefault();
            if (!!submit) {
                const returned = submit($(e.target).data('value'));

                if(!!returned && !!returned.then){
                    returned.then(x =>{
                        _close($template);
                    });

                    return;
                }
            }

            return _close($template);
        };

        const _cancel = e => {
            e.preventDefault();
            if (close) {
                close($(e.target).data('value'));
            }

            Workspace.addAction(new Item(`.btn-action-close`, '', ControlType.DialogOption, 1));

            return _close($template);
        };

        $template = $(templates('dialog-select', {
            options: values
        }));
        $template.find('.btn-option').on('click', _submit);
        $template.find('.btn-default').on('click', _cancel);

        $dialog = $template.kendoWindow({
            width: '240px',
            resizable: false,
            draggable: false,
            visible: false,
            title: false,
            appendTo: 'body',
            close: _onClose
        }).data('kendoWindow');

        $dialog.center().open();

        return $dialog;
    };
})();

export default select;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/select.js